import {defer, merge, Observable, of, Subject} from 'rxjs';

export const storageUtil = {
  readStorageObject<T extends StorageObject>(key, defaultValue: T): T {
    const cacheString = localStorage.getItem(key);
    if (cacheString) {
      try {
        const cacheConfig = <T>JSON.parse(cacheString);
        if (cacheConfig.version === defaultValue.version) {
          return {...defaultValue, ...cacheConfig};
        }
      } catch (e) {}
    }
    return defaultValue;
  },
  writeStorageObject(STORAGE_KEY, object) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(object));
  },
};

export function convertStorageToObservable<T, P extends any[]>({
  read,
  write,
}: {
  read: () => T;
  write: (...args: P) => T;
}): {
  storage$: Observable<T>;
  writeStorage: (...args: P) => T;
} {
  const updateNotifier$: Subject<T> = new Subject();
  const firstValue$ = defer(() => of(read()));

  function writeStorage(...params: P) {
    const value = write(...params);
    updateNotifier$.next(value);
    return value;
  }
  return {
    storage$: merge(firstValue$, updateNotifier$),
    writeStorage,
  };
}
